import { Text, Flex, Box } from '@chakra-ui/react';
import React from 'react';

import type { TChainIndicator } from './types';

import { Skeleton } from 'toolkit/chakra/skeleton';

interface Props {
  indicator: TChainIndicator;
  isLoading: boolean;
}

const ChainIndicatorItem = ({ indicator, isLoading }: Props) => {
  const valueContent = (() => {
    if (indicator.value.includes('N/A')) {
      return <Text color="text.secondary" fontWeight={ 400 }>no data</Text>;
    }

    return (
      <Skeleton loading={ isLoading } fontWeight={ 600 } minW="30px">
        { indicator.value }
      </Skeleton>
    );
  })();

  const valueDiffContent = (() => {
    if (indicator.valueDiff === undefined) {
      return null;
    }

    const diffColor = indicator.valueDiff >= 0 ? 'green.500' : 'red.500';

    return (
      <Skeleton loading={ isLoading } ml={ 1 } display="flex" alignItems="center" color={ diffColor }>
        <span>{ indicator.valueDiff >= 0 ? '+' : '-' }</span>
        <Text color={ diffColor } fontWeight={ 600 }>{ Math.abs(indicator.valueDiff) }%</Text>
      </Skeleton>
    );
  })();

  return (
    <Flex
      alignItems="center"
      columnGap={ 2 }
      flex={ 1 }
      px={ 3 }
      py={ 2 }
      as="li"
      borderRadius="base"
      bgColor="bg.secondary"
      fontSize="sm"
      fontWeight={ 500 }
      minW="0"
    >
      <Flex flexShrink={ 0 }>
        { indicator.icon }
      </Flex>
      <Box minW="0" flex={ 1 }>
        <Text fontSize="xs" color="text.secondary" mb={ 1 }>
          { indicator.titleShort || indicator.title }
        </Text>
        <Flex alignItems="center" color="text.primary">
          { valueContent }
          { valueDiffContent }
        </Flex>
      </Box>
    </Flex>
  );
};

export default React.memo(ChainIndicatorItem);
